import { defaultUnderlying } from "#/config/markets";
import { getOptionConstraints } from "#/config/orders";
import { SLIPPAGE_CONFIG } from "#/config/slippage";
import { Option } from "#/types/options";

import { useDeltaSlippage } from "./useDeltaSlippage";

export const useOptionSlippage = (option?: Option) => {
  const {
    lowDeltaSlippageFactor,
    midDeltaSlippageFactor,
    highDeltaSlippageFactor,
  } = useDeltaSlippage();

  const market = option?.underlying || defaultUnderlying;
  const { priceDisplayPrecisionNotional, sizeDisplayPrecision } =
    getOptionConstraints(market);
  const createPayload = (slippageFactor: number) => ({
    optionSlippageFactor: slippageFactor,
    priceDisplayPrecisionNotional,
    sizeDisplayPrecision,
  });

  if (option?.delta === undefined) {
    // 0 ∆ is ok, we want to handle potential undefined case;
    return createPayload(0);
  }
  const delta = Math.abs(option?.delta || 0);

  if (delta >= SLIPPAGE_CONFIG.options.highDelta.conservativeThreshold) {
    return createPayload(highDeltaSlippageFactor);
  }

  if (delta >= SLIPPAGE_CONFIG.options.midDelta.conservativeThreshold) {
    return createPayload(midDeltaSlippageFactor);
  }

  return createPayload(lowDeltaSlippageFactor);
};
